import type { ChromeMatrix, ChromeSpec } from '../../core/template/types'

// Today's per-page chrome (§4.5): classic's views keep every mount site
// where it is; this matrix only describes them for the contract test.
const SPACED_FOOTER: ChromeSpec = { header: 'spaced', footer: true }
const SPACED_ONLY: ChromeSpec = { header: 'spaced', footer: false }
const OVERLAY_FOOTER: ChromeSpec = { header: 'overlay', footer: true }
const allStatuses = (s: ChromeSpec) => ({ ready: s, loading: s, error: s, notFound: s })
const footerWhenReady = { ready: SPACED_FOOTER, loading: SPACED_ONLY, error: SPACED_ONLY, notFound: SPACED_ONLY }

export const CLASSIC_CHROME: ChromeMatrix = {
  home: allStatuses(OVERLAY_FOOTER),
  schedule: allStatuses(SPACED_ONLY),
  game: allStatuses(SPACED_ONLY),
  page: allStatuses(SPACED_ONLY),
  liveEvents: allStatuses(SPACED_ONLY),
  liveEvent: allStatuses(SPACED_ONLY),
  player: footerWhenReady,
  team: footerWhenReady,
  sponsor: footerWhenReady,
  stats: allStatuses(SPACED_FOOTER),
  players: allStatuses(SPACED_FOOTER),
  teams: allStatuses(SPACED_FOOTER),
  blog: allStatuses(SPACED_FOOTER),
  gallery: allStatuses(SPACED_FOOTER),
  venues: allStatuses(SPACED_FOOTER),
  venue: allStatuses(SPACED_FOOTER),
  tickets: allStatuses(SPACED_FOOTER),
  // SalePage's loading branch mounts the nav without a footer (SalePage.tsx loading return).
  sale: { ready: SPACED_FOOTER, loading: SPACED_ONLY, error: SPACED_FOOTER, notFound: SPACED_FOOTER },
  // pages/SignIn.tsx mounts Navigation and LeagueFooter in every status.
  signIn: allStatuses(SPACED_FOOTER),
  // pages/Registrations.tsx and Registration.tsx mount Navigation and
  // LeagueFooter in every status (registration plan step 6).
  registrations: allStatuses(SPACED_FOOTER),
  registration: allStatuses(SPACED_FOOTER),
  // My account and password recovery (registration plan step 9): Navigation
  // and LeagueFooter in every status.
  account: allStatuses(SPACED_FOOTER),
  forgotPassword: allStatuses(SPACED_FOOTER),
  resetPassword: allStatuses(SPACED_FOOTER),
  join: allStatuses(SPACED_FOOTER),
  // pages/MembersOnly.tsx (registration step 33) mounts neither: the nav
  // menu and the footer links are league content the gate refuses.
  membersOnly: allStatuses({ header: 'none', footer: false }),
}

